import { useSearchParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import styled from '@emotion/styled';
import { getPaywallMetaFromUrl } from '@/utils/paywallUrlParams';

const Footer = styled.footer`
  display: flex;
  justify-content: center;
  padding: 20px 0;
`;

const Restore = styled.div`
  a {
    font-size: 14px;
    font-weight: 600;
    color: #31bcf9;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
`;

export function RestoreSubscription() {
  const [searchParams] = useSearchParams();
  const metaParam = getPaywallMetaFromUrl(searchParams);

  const restoreUrl = metaParam
    ? `/login?restore=true&meta=${encodeURIComponent(metaParam)}`
    : '/login?restore=true';

  return (
    <Footer>
      <Restore>
        <Link to={restoreUrl}>Restore subscription</Link>
      </Restore>
    </Footer>
  );
}
